import React from 'react'

import { InformationCard } from '@frame/ui-components/information-card'
import { UnorderedList } from '@frame/ui-components/unordered-list'
import { P } from '@frame/ui-primitives/p'
import { Span } from '@frame/ui-primitives/span'

export function PaystubInfo() {
  return (
    <InformationCard>
      <P className="text-sm">
        <Span className="font-bold">What is a paystub?</Span> A document that shows how much you earned and what was
        deducted - like taxes and insurance.
      </P>
      <UnorderedList
        className="text-sm"
        title="It includes:"
        items={[
          'Your name',
          'Dates you worked',
          'Total pay',
          'Deductions (like taxes)',
          'Final take-home pay (after deductions)',
        ]}
      />
      <P className="text-sm">
        <Span className="font-bold">Where can I find mine?</Span> If you're not sure, ask your employer or check your
        employer's online portal.
      </P>
    </InformationCard>
  )
}
